import * as types from "./consultarProtocolo.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  tokenRecaptcha: "",
  tokenRecaptchaModal: "",
  HeaderDocumento: {},
  PesquisaProtocoloModalToggle: false,
  GridConsultarProtocoloPesquisa: [],
  GridConsultarProtocolo: [],
  ViewAnaliseModalToggle: false,
  ViewAnalise: {},
  recaptchaResetRef:undefined,
  recaptchaResetRefModal:undefined,
});

const reduce = (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.SET_TOKEN_RECAPTCHA_MODAL:
      return state.merge({ tokenRecaptchaModal: payload });
    case types.TOGGLE_MODAL_CONSULTAR_PROTOCOLO:
      return state.merge({ PesquisaProtocoloModalToggle: !state.PesquisaProtocoloModalToggle });
    case types.SET_GRID_PESQUISA_CONSULTAR_PROTOCOLO:
      return state.merge({ GridConsultarProtocoloPesquisa: payload });
    case types.SET_GRID_CONSULTAR_PROTOCOLO:
      return state.merge({ GridConsultarProtocolo: payload });
    case types.SET_HEADER_CONSULTAR_PROTOCOLO:
      return state.merge({ HeaderDocumento: payload });
    case types.TOOGLE_MODAL_VIEW_ANALISE:
      return state.merge({ ViewAnaliseModalToggle: !state.ViewAnaliseModalToggle });
    case types.SET_VIEW_ANALISE:
      return state.merge({ ViewAnalise: payload });
    case types.LIMPA_GRIDS_CONSULTAR_PROTOCOLO:
      return state.merge({ GridConsultarProtocoloPesquisa: [], GridConsultarProtocolo: [] });
    case types.SET_RECAPTCHA_RESET_REF:
      return state.merge({ recaptchaResetRef: payload });
    case types.SET_RECAPTCHA_RESET_REF_MODAL:
      return state.merge({ recaptchaResetRefModal: payload });
    case commonActionType.RESET:
        return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule("redeSIM.consultarProtocolo", reduce);
